import { assertApiBaseForFetch } from './apiHooks/getApiUrl/getApiUrl.functions.ts';
import { type AuthUser, authorizationHeader } from './authorizationHeader.ts';
import { handleResponseErrors } from './handleResponseErrors.ts';

type FetchAuthApiGetArgs = {
  api: string | undefined;
  route: string;
  user?: AuthUser;
  headers?: HeadersInit;
  signal?: AbortSignal;
  identifier?: string;
  returnJsonResult?: boolean;
  returnStringResult?: boolean;
};

/**
 * Authenticated GET used by {@link useAuthApiGetSingleFetch}: {@link authorizationHeader}, `response.ok` via
 * {@link handleResponseErrors}, URL as `${base}${route}`.
 */
export const fetchAuthApiGet = async <T>({
  api,
  route,
  user,
  headers,
  signal,
  identifier,
  returnJsonResult,
  returnStringResult,
}: FetchAuthApiGetArgs): Promise<T> => {
  const base = assertApiBaseForFetch(api).replace(/\/+$/, '');
  const response = await fetch(`${base}${route}`, {
    ...(signal ? { signal } : {}),
    headers: {
      ...authorizationHeader(user),
      ...(returnStringResult ? { accept: 'text/plain' } : {}),
      ...headers,
    },
  });

  return await handleResponseErrors<T>(response, identifier, returnJsonResult, returnStringResult);
};
